"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.segmentDefinition = void 0;
const firestore_1 = require("comodel/firestore");
const project_1 = require("./project");
exports.segmentDefinition = (0, firestore_1.defineCollection)({
    collectionName: "segment",
    idKey: "segmentId",
    parent: project_1.projectDefinition,
    constraints: ["projectId"],
    queryDefs: {
        list: ({ projectId, condition, deleted, }) => {
            return {
                constraint: { projectId },
                queryParams: {
                // orderBy: [["createdAt", "desc"]],
                },
                filterParams: Object.assign(Object.assign({}, condition), (deleted
                    ? { deletedAt: { $exists: true } }
                    : { deletedAt: { $exists: false } })),
            };
        },
        listBySegmentName: ({ projectId, segmentName, }) => {
            return {
                constraint: { projectId },
                queryParams: {
                    filter: { segmentName },
                    // orderBy: [["createdAt", "desc"]],
                },
            };
        },
    },
    defaultValue: {},
    onGenerate: (o) => (Object.assign(Object.assign({}, o), { createdAt: Date.now() })),
    onWrite: (o) => (Object.assign(Object.assign({}, o), { updatedAt: Date.now() })),
});
